import { Component, OnDestroy, OnInit } from '@angular/core'
import { source } from './source'

const SCRIPT_NAME = 'govbarScript'

@Component({
  selector: 'app-govbar',
  templateUrl: './govbar.component.html',
  styleUrls: ['./govbar.component.scss'],
})
export class GovbarComponent implements OnInit, OnDestroy {
  private injectScript() {
    setTimeout(() => {
      this.removeScript()
      const script = document.createElement('script')
      script.id = SCRIPT_NAME
      script.async = true
      script.type = 'text/javascript'
      script.innerHTML = source
      document.body.appendChild(script)
    })
  }

  private removeScript() {
    const elementStript = document.getElementById(SCRIPT_NAME)
    if (elementStript) {
      elementStript.remove()
    }
  }

  ngOnInit(): void {
    this.injectScript()
  }

  ngOnDestroy(): void {
    this.removeScript()
  }
}
